export const VENDOR_ROUTE = '/vendor/';
export const SHOPS_LIST_ROUTE = VENDOR_ROUTE + 'shops/';
export const SHOP_ROUTE = VENDOR_ROUTE + 'Shop/';
export const INSERTION_ROUTE = VENDOR_ROUTE + 'Insertion/';
export const ARTICLE_LIST_ROUTE = VENDOR_ROUTE + 'articles/';
export const ARTICLE_ROUTE = VENDOR_ROUTE + 'article/';
export const COUPON_REDEEM_ROUTE = VENDOR_ROUTE + 'couponRedeem/';
export const COUPON_LIST_ROUTE = VENDOR_ROUTE + 'couponList/';
export const DEFAULT_PREFIX = '';
export const ADVERTISEMENT_ROUTE = VENDOR_ROUTE +'advertisements'